import PropTypes from 'prop-types';

/**
 * The PageWrapper component.
 * @param {object} props The props.
 * @param {JSX.Element} props.children The children.
 * @returns {JSX.Element} The rendered PageWrapper component.
 */
const PageWrapper = ({ children }) => children;

PageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
export default PageWrapper;
